var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60.000000pt",
    height: "60.000000pt",
    viewBox: "0 0 60.000000 60.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,60.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203 582 c-251 -90 -272 -432 -35 -549 81 -40 183 -40 264 0 107 53 163 144 163 267 0 85 -21 142 -74 203 -72 81 -213 117 -318 79z m224 -35 c136 -70 190 -236 120 -373 -62 -122 -197 -179 -332 -140 -79 23 -156 100 -179 176 -34 113 -11 206 68 286 89 88 211 107 323 51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 487 c-12 -13 -22 -29 -22 -36 0 -7 30 -44 67 -82 l66 -69 -66 -69 c-37 -38 -67 -75 -67 -83 0 -8 11 -25 25 -38 18 -17 29 -21 43 -14 35 18 182 182 182 204 0 13 -32 55 -82 108 -112 118 -110 117 -146 79z m126 -86 c45 -49 82 -95 82 -103 -1 -7 -39 -53 -86 -103 l-84 -89 -22 22 -22 21 67 70 c37 38 67 74 67 81 0 7 -30 43 -67 81 -65 67 -66 69 -48 89 10 11 21 20 24 20 3 0 43 -40 89 -89z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.0714dab7be3e4f9482d1777f54457060.svg";
export { ForwardRef as ReactComponent };